import { ToastService } from "./ToastService";
import Swal from "sweetalert2";

export const responses = {
    throwErr(err,title = `An Error Occurred`){
        return Swal.fire({
            title: title,
            icon: `warning`,
            html : `<p>${err}</p>`,
            showCloseButton : true,
        })
    },

    showSuccess(msg){
        return ToastService.success(msg);
    },

    showInfo(msg){
        return ToastService.info(msg);
    },

    showWarning(msg){
        return ToastService.warning(msg);
    },
}
